import { useScrollReveal } from "@/hooks/useScrollReveal";

const services = [
  {
    id: "limpeza-pele",
    title: "Limpeza de Pele Profunda",
    description:
      "Protocolo completo de higienização facial com extração profissional, vapor de ozônio, ledterapia e máscara personalizada de acordo com cada tipo de pele. Indicado para todos os tipos de pele, remove impurezas, reduz poros dilatados e devolve o viço natural.",
  },
  {
    id: "tratamento-manchas",
    title: "Tratamento para Manchas e Acne",
    description:
      "Protocolo não invasivo que combina ativos clareadores de última geração e peelings enzimáticos para tratar hiperpigmentação, marcas de acne e uniformizar o tom da pele. Tecnologia LED auxilia na regeneração celular sem agredir a pele.",
  },
  {
    id: "consultoria-home-care",
    title: "Consultoria de Rotina Home Care",
    description:
      "Anamnese detalhada e personalizada com análise completa da pele, identificação de necessidades específicas e prescrição de rotina de cuidados diários. Inclui guia de produtos, ordem de aplicação e acompanhamento para garantir resultados consistentes.",
  },
];

export default function FacialServices() {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.1 });

  return (
    <section id="servicos-faciais" className="py-20 md:py-32 bg-background-100">
      <div
        ref={ref}
        className={`max-w-7xl mx-auto px-6 md:px-10 transition-all duration-1000 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="max-w-2xl mb-16">
          <p className="flex items-center gap-3 font-label text-[11px] md:text-xs uppercase tracking-[0.3em] text-primary-600 mb-6">
            <span className="w-10 h-[1px] bg-primary-500/60" />
            Tratamentos Exclusivos
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mb-5 leading-tight">
            Serviços Faciais
          </h2>
          <p className="text-foreground-500 text-sm md:text-base font-light leading-relaxed">
            Protocolos personalizados para revelar a melhor versão da sua pele
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-7">
          {services.map((service, i) => (
            <article
              key={service.id}
              className="group flex flex-col bg-background-50 border border-background-200 hover:border-primary-300 rounded-2xl p-7 md:p-8 transition-colors duration-500"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <span className="font-heading text-4xl font-bold text-primary-500/30 mb-5 block">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-4 leading-snug">
                {service.title}
              </h3>
              <p className="text-sm text-foreground-600 font-light leading-relaxed mb-7 flex-1">
                {service.description}
              </p>
              <a
                href="https://wa.me/5547991654435?text=Ol%C3%A1%20Jennifer%2C%20gostaria%20de%20saber%20valores%20e%20agendar%20um%20hor%C3%A1rio!"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 border border-foreground-900 hover:bg-foreground-900 text-foreground-900 hover:text-background-50 px-6 py-3 rounded-md text-[12px] font-label uppercase tracking-[0.14em] transition-all duration-300 whitespace-nowrap cursor-pointer w-full"
              >
                Consultar Valores
                <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <p className="text-[11px] text-foreground-400 font-light mt-3 text-center">
                Entre em contato para saber valores e disponibilidade
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}